import React from 'react'
import LinkRedoute from '@redoute/link'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { useLocation } from 'react-router-dom'

const LinkStyled = styled(LinkRedoute)(
  ({ theme }) => css`
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    line-height: 130%;
    text-decoration: none;
    color: ${theme.white};
    &:active {
      text-decoration: none;
    }
    :hover {
      text-decoration: none;
    }
  `
)

// keep params when browsing
const LinkWithParams = (props) => {
  const location = useLocation()
  return (
    <LinkStyled
      {...props}
      to={{
        pathname: props.to,
        search: location.search
      }}
    />
  )
}

export default LinkWithParams
